export const API_HOST = 'https://stage-api.ruptly.online';
export const VOD_HOST = 'https://stage.ruptly.online';
export const LIVE_HOST = 'https://stage-live.ruptly.online';
export const STATIC_HOST = 'https://devstaging.ruptly.online';
export const STRIPE_API_KEY = 'pk_test_lDwsCASDrdL3ZKq9MqsFAuCD';
export const WS_URI = "wss://api.ruptly.online/cable";
export const COMMON_DOMAIN = '.ruptly.online';
export const PLAUSIBLE_SCRIPT_PATH = 's3.eu-west-1.amazonaws.com/vodstorage.ruptly.online';
